<template>

    <v-page fixed>

        <transition name="modal">
            <v-modal-trait-create v-if="showModal === 'create'" @created="getTraits" />
            <v-modal-trait-delete v-if="showModal === 'delete'" :trait="selectedTrait" @deleted="getTraits" />
            <v-modal-trait-restore v-if="showModal === 'restore'" :trait="selectedTrait" @restored="getTraits" />
        </transition>

        <v-page-header title="Traits" icon="fas fa-fingerprint" />

        <v-page-filters>
            <v-button-toolbar size="sm">
                <v-searchbar ref="search" :model="params.q" :action="search" />
                <v-dropdown
                    prefix="Type"
                    :items="[
                        {key: null, value: 'Any'},
                        {key: 'string', value: 'String'},
                        {key: 'number', value: 'Number'},
                        {key: 'boolean', value: 'Boolean'},
                        {key: 'date', value: 'Date'},
                    ]"
                    :selected="params.type"
                    @change="onFilterSelected('type', $event)">
                </v-dropdown>
                <v-dropdown
                    prefix="Filter"
                    :items="[
                        {key: null, value: 'All'},
                        {key: 'deleted', value: 'Deleted'},
                    ]"
                    :selected="params.filter"
                    @change="onFilterSelected('filter', $event)">
                </v-dropdown>
            </v-button-toolbar>
            <v-button size="sm" @click.native="createTrait">Create Trait</v-button>
        </v-page-filters>

        <v-page-body>

            <v-notice v-if="!traits.length" title="No Traits Found" message="Waiting for customer traits to be added to your project.">
                <template #footer>
                    <v-button @click.native="createTrait">Create Trait</v-button>
                </template>
            </v-notice>

            <v-page-section padded v-else>
                <template #body>
                    <v-table :selectable="true" :bordered="true">
                        <thead>
                            <th>Name</th>
                            <th>Field</th>
                            <th>Type</th>
                            <th>Format</th>
                            <th></th>
                        </thead>
                        <tbody>
                            <tr v-for="trait in traits" :key="trait.id" @click="editTrait(trait)" :class="{ 'table-danger': trait.deleted_at !== null }">
                                <td>{{ trait.name }}</td>
                                <td>{{ trait.field }}</td>
                                <td>{{ trait.type }}</td>
                                <td>{{ trait.format }}</td>
                                <td v-if="!trait.deleted_at">
                                    <v-button-toolbar class="float-right">
                                        <v-button size="xs" btn-style="secondary" @click.native.stop="editTrait(trait)">Edit</v-button>
                                        <v-button size="xs" btn-style="secondary" @click.native.stop="deleteTrait(trait)">Delete</v-button>
                                    </v-button-toolbar>
                                </td>
                                <td v-else>
                                    <v-button-toolbar class="float-right">
                                        <v-button size="xs" btn-style="secondary" @click.native.stop="restoreTrait(trait)">Restore</v-button>
                                    </v-button-toolbar>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </template>
            </v-page-section>

        </v-page-body>

    </v-page>

</template>

<script>

import ModalTraitCreate from '@modals/trait/ModalTraitCreate';
import ModalTraitDelete from '@modals/trait/ModalTraitDelete';
import ModalTraitRestore from '@modals/trait/ModalTraitRestore';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-modal-trait-create': ModalTraitCreate,
        'v-modal-trait-delete': ModalTraitDelete,
        'v-modal-trait-restore': ModalTraitRestore,
    },

    data() {
        return {
            traits: [],
            selectedTrait: {},
            params: {
                is_deleted: 0,
                type: null,
                filter: null,
            },
        }
    },

    mounted() {
        this.params = this.$route.query;
        this.getTraits();
    },

    watch: {

        $route(val) {
            this.params = val.query;
            this.getTraits();
        },

    },

    methods: {

        onFilterSelected(key, item) {
            let query = Object.assign({}, this.$route.query);
            query[key] = item.key;
            this.$router.replace({ query: query }).catch(() => {
                this.getTraits();
            });
        },

        search() {
            let query = Object.assign({}, this.$route.query);
            query.q = this.$refs.search.val;
            this.$router.replace({ query: query }).catch(() => {
                this.getTraits();
            });
        },

        getTraits() {
            this.$store.commit('loading', true);
            ProjectApi.getTraits(this.project.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.traits = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        editTrait(trait) {
            if (!trait.deleted_at) {
                this.$router.push({ name: 'traits-edit', params: { id: trait.id } });
            }
        },

        createTrait() {
            this.$store.commit('showModal', 'create');
        },

        deleteTrait(trait) {
            this.selectedTrait = trait;
            this.$store.commit('showModal', 'delete');
        },

        restoreTrait(trait) {
            this.selectedTrait = trait;
            this.$store.commit('showModal', 'restore');
        },

    },

}

</script>